/**
 * Created by Alican Köker on 2019-02-25.
 */
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {EdisonGameConfig} from "../game/EdisonGameConfig";
import { EdisonStateReelSymbol } from "../game/reel/reelSymbol/EdisonStateReelSymbol";
import { EdisonParsedGameData } from "../game/server/data/EdisonParsedGameData";

export function isNumber(value:any):value is number {
    return typeof value === "number" && value === value;
}

export class EdisonHelper {

    public static getSymbolPosition(reelIndex:number, symbolIndex:number):number[] {
        let pos:number[] = [0, 0];

        let reelAreaPosX:number = EdisonGameConfig.instance.REEL_AREA_POS_X;
        let reelAreaPosY:number = EdisonGameConfig.instance.REEL_AREA_POS_Y;
        let symbolWidth:number = EdisonGameConfig.instance.SYMBOL_WIDTH;
        let symbolHeight:number = EdisonGameConfig.instance.SYMBOL_HEIGHT;
        let symbolPadding:number = EdisonGameConfig.instance.SYMBOL_BOTTOM_PADDING

        let posX:number = reelAreaPosX + reelIndex * symbolWidth;
        let posY:number = reelAreaPosY + symbolIndex * (symbolHeight + symbolPadding);

        pos[0] = posX;
        pos[1] = posY;

        return pos;
    }


    public static sortSymbolLayerLevels(reelId:number):void {
        for(let i:number = 0; i < 4; i++) {
            let sym1:EdisonStateReelSymbol = <EdisonStateReelSymbol>Reels.getSymbol(reelId, i);
            let sym2:EdisonStateReelSymbol = <EdisonStateReelSymbol>Reels.getSymbol(reelId, i + 1);
            if(!sym1 || !sym2)
                return;
            if(sym1.symName.charAt(0) !== "L" && sym2.symName.charAt(0) !== "L")
                Reels.moveSymbolToTop(reelId, i + 1);
        }
    }

    public static checkStacked(gameData:EdisonParsedGameData, reelId:number):boolean {
        return gameData.stackedModeOverlay[reelId];
    }

    public static calculateNearFreespinReels(reels:string[][]):boolean[] {
        let nearFSReels:boolean[] = [false, false, false, false, false];
        let count = 0;

        reels.forEach((reel, index) => {
            reel.forEach((symbol) => {
                if(symbol === "S") {
                    count++;
                }

                if(count > 1 && index !== 4)
                    nearFSReels[index] = true;
            });
        });

        return nearFSReels;
    }

    public static getWinRatio(currentWinRatio:number):number {

        for(let i:number = 0; i < (EdisonGameConfig.instance.WIN_RATIOS.normalWin.length - 1); i++) {

            if(currentWinRatio >= EdisonGameConfig.instance.WIN_RATIOS.normalWin[i].ratio &&
                currentWinRatio < EdisonGameConfig.instance.WIN_RATIOS.normalWin[i + 1].ratio) {
                return i;
            }
        }
        return 3;
    }

    public static pointSub(p1:PIXI.Point ,p2n:PIXI.Point | number):PIXI.Point{
        if(isNumber(p2n)) return  new PIXI.Point(p1.x - p2n, p1.y - p2n);
        return new PIXI.Point(p1.x - p2n.x, p1.y - p2n.y );
    }
}